<template>
  <v-autocomplete
    variant="plain"
    v-model="model"
    v-model:search="search"
    :items="roles"
    item-title="name"
    item-value="id"
    placeholder="Role"
    :loading="!!loading"
    :readonly="readonly"
    ref="autocomplete"
  >
    <template #append-item>
      <v-list-item
        v-if="search"
        selectable
        title="Create New Role"
        value="new"
        :loading="!!loading"
        @click="newRole(search)"
      />
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import { Role } from "@/classes";
import { useListStore } from "@/store/lists";

import { defineModel, ref } from "vue";
import { VAutocomplete } from "vuetify/lib/components/index.mjs";
import { setupApiQueue } from "../base/api-queue";

const props = withDefaults(
  defineProps<{
    readonly?: boolean;
  }>(),
  {
    readonly: false,
  }
);

const model = defineModel();
const lists = useListStore();
const roles = lists.useList<Role>("roles");

const search = ref<string>("");

const { queueApiAction, loading } = setupApiQueue();

const newRole = (name: string) => {
  queueApiAction(async () => {
    const oldRole = roles.value.find((r) => r.name === name);
    if (oldRole) {
      model.value = oldRole.id;
    } else {
      const role = new Role();
      role.name = name;
      model.value = role.id;
      await role.save();
      lists.refreshList("roles");
    }
  });
};
</script>
